import React, { useState } from "react";
import { Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

export default function Start_6_V6({
  version = "v6",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<number | null>(null);

  const pageKey = "start_6";
  const { updateSingleSelection } = useOnboardingPromotionPage({
    pageKey,
  });

  const handleOptionSelect = (optionId: number) => {
    setSelected(optionId);
    updateSingleSelection(optionId);
    setTimeout(() => {
      navigate(`/${versionToPathPrefix(version)}-onboarding/start/7`, {
        replace: true,
      });
    }, 300);
  };

  return (
    <Stack spacing={5} sx={{ paddingBottom: "80px" }}>
      <CustomTypography
        variant="Subtitle"
        fontWeight={500}
        sx={{ color: theme.vars.palette.Content.Strong }}
      >
        {
          "현재의 익숙한 괴로움에 머물겠습니까, 아니면 낯선 불편함을 감수하고 변화하시겠습니까?"
        }
      </CustomTypography>

      <Stack direction={"column"} sx={{ width: "100%", gap: 1 }}>
        <Button
          fullWidth
          variant={"SingleSlim"}
          size={"lg"}
          color={selected === 1 ? "primary" : "secondary"}
          sx={{ transition: "background-color 0.3s ease" }}
          onClick={() => handleOptionSelect(1)}
        >
          불편함을 감수할 준비가 되었다
        </Button>
        <Button
          fullWidth
          variant={"SingleSlim"}
          size={"lg"}
          color={selected === 2 ? "primary" : "secondary"}
          sx={{ transition: "background-color 0.3s ease" }}
          onClick={() => handleOptionSelect(2)}
        >
          아직은 용기가 나지 않는다
        </Button>
      </Stack>
    </Stack>
  );
}
